module.exports = __webpack_public_path__ + "img/pdf_poster_background.29da6d44.png";